import { getTranslations } from "next-intl/server";

export const PAGES:any = {
  HOME : '/',
  THEMES : '/themes',
  ABOUT_US : '/about-us',
  NEWS : '/news',
  SERVICES : '/services',
  CONTACT : '/contact',
  JOBS : '/jobs',
  LEGAL : '/legal',
}


